import { render, staticRenderFns } from "./QType1GroupItem.vue?vue&type=template&id=0b5f8433&scoped=true&"
import script from "./QType1GroupItem.vue?vue&type=script&lang=js&"
export * from "./QType1GroupItem.vue?vue&type=script&lang=js&"
import style0 from "./QType1GroupItem.vue?vue&type=style&index=0&id=0b5f8433&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5f8433",
  null
  
)

export default component.exports